export const MODEL_SORT_KEY_V1021 = 'alfredapi.model.sort.v1021';
export const MODEL_SORTS_V1021 = [
  'newest',
  'oldest',
  'provider',
  'capability',
  'usage',
  'success',
  'latency',
  'name',
];

export function catalogSortPreferenceV1021(storage) {
  try {
    const stored = storage.getItem(MODEL_SORT_KEY_V1021);
    return MODEL_SORTS_V1021.includes(stored) ? stored : 'newest';
  } catch {
    return 'newest';
  }
}

export function catalogDateV113(item, now = Date.now()) {
  // An explicit dated model ID is a version date, not a guessed launch date.
  // Never interpret parameter counts or a free-form display label as a date.
  const name = String(item.model_name || '');
  const matches = [
    ...name.matchAll(
      /(?:^|[-_/])((?:20)?\d{2})-?(\d{2})-?(\d{2})(?=$|[-_:/.])/g
    ),
  ];
  for (const match of matches.reverse()) {
    const year = Number(match[1].length === 2 ? `20${match[1]}` : match[1]);
    const month = Number(match[2]),
      day = Number(match[3]);
    const time = Date.UTC(year, month - 1, day);
    const date = new Date(time);
    if (
      year >= 2020 &&
      time <= now &&
      date.getUTCFullYear() === year &&
      date.getUTCMonth() === month - 1 &&
      date.getUTCDate() === day
    ) {
      return { timestamp: time / 1000, source: 'modelDate' };
    }
  }
  const value = item.openrouter_created_at_v1021;
  return Number.isSafeInteger(value) &&
    value > 0 &&
    value * 1000 <= now + 86400000
    ? { timestamp: value, source: 'listedDate' }
    : { timestamp: 0, source: 'unknownDate' };
}

export function compareCatalogNameV113(left, right) {
  return (
    String(left.model_name).localeCompare(String(right.model_name), 'en', {
      numeric: true,
      sensitivity: 'base',
    }) || String(left.model_name).localeCompare(String(right.model_name), 'en')
  );
}

export function compareCatalogDateV113(left, right, oldest = false) {
  const a = catalogDateV113(left).timestamp,
    b = catalogDateV113(right).timestamp;
  if (Boolean(a) !== Boolean(b)) return a ? -1 : 1;
  return (oldest ? a - b : b - a) || compareCatalogNameV113(left, right);
}

export function compareCatalogNewestV1021(left, right) {
  return compareCatalogDateV113(left, right);
}

export function catalogIntelligenceV113(item, now = Date.now()) {
  const value = item.benchmark_v113;
  if (
    value?.source !== 'artificial-analysis-via-openrouter' ||
    typeof value.intelligence_index !== 'number' ||
    !Number.isFinite(value.intelligence_index) ||
    value.intelligence_index < 0 ||
    value.intelligence_index > 1000 ||
    !Number.isSafeInteger(value.updated_at) ||
    value.updated_at <= 0 ||
    value.updated_at * 1000 > now + 86400000
  )
    return null;
  return { ...value, stale: now - value.updated_at * 1000 > 7 * 86400000 };
}

export function compareCatalogCapabilityV113(left, right) {
  const a = catalogIntelligenceV113(left),
    b = catalogIntelligenceV113(right);
  const knownA = a !== null && !a.stale,
    knownB = b !== null && !b.stale;
  if (knownA !== knownB) return knownA ? -1 : 1;
  return (
    (knownA ? b.intelligence_index - a.intelligence_index : 0) ||
    compareCatalogNewestV1021(left, right)
  );
}

export function compareCatalogProviderV113(left, right) {
  const a = left.presentation?.providerKey || 'custom';
  const b = right.presentation?.providerKey || 'custom';
  if ((a === 'custom') !== (b === 'custom')) return a === 'custom' ? 1 : -1;
  return (
    String(left.presentation?.provider?.name || a).localeCompare(
      String(right.presentation?.provider?.name || b),
      'en',
      { sensitivity: 'base' }
    ) || compareCatalogNewestV1021(left, right)
  );
}

export function catalogRecencyTextV1021(language) {
  return language?.startsWith('zh')
    ? {
        newest: '\u6700\u65b0\u4f18\u5148',
        channels: '\u5df2\u767b\u8bb0\u6e20\u9053',
        enabled: '\u5df2\u542f\u7528',
        manual: '\u624b\u52a8\u505c\u7528',
        automatic: '\u81ea\u52a8\u505c\u7528',
        unknown: '\u72b6\u6001\u672a\u77e5',
        empty: '\u6682\u65e0\u6e20\u9053\u660e\u7ec6',
      }
    : {
        newest: 'Newest first',
        channels: 'Registered channels',
        enabled: 'Enabled',
        manual: 'Manually disabled',
        automatic: 'Automatically disabled',
        unknown: 'Unknown status',
        empty: 'Channel details unavailable',
      };
}
